import {makeDropdownSelectorControl} from '../../controls/dropdown-selector-control/dropdown-selector-control';
import {BORDER_STYLE_PROPERTY, borderStyleDescriptor, isBorderStyleNonNone} from '../../controls/dropdown-selector-control/dropdown-selector-control-descriptors';
import {makeConditionalControl} from '../../controls/conditional-control/conditional-control';
import {ConditionalGatingSource} from '../../controls/conditional-control/conditional-control.types';
import {makeColorControl} from '../../controls/color-control/color-control';
import {borderColorDescriptor} from '../../controls/color-control/color-control-descriptors';
import {makeSliderControl} from '../../controls/slider-control/slider-control';
import {borderWidthDescriptor} from '../../controls/slider-control/slider-control-descriptors';
import type {EmailMakerControl} from '../../right-panel-registry.types';

/**
 * Shared border triad: a style dropdown plus color and width rows that self-gate on the style value.
 * The produced controls are stateless singletons (editor from context, component from props), so sharing instances is safe.
 */
export const borderStyleControl: EmailMakerControl = makeDropdownSelectorControl(borderStyleDescriptor);

const borderColorControl: EmailMakerControl = makeColorControl(borderColorDescriptor);
const borderWidthControl: EmailMakerControl = makeSliderControl(borderWidthDescriptor);

export const conditionalBorderColorControl: EmailMakerControl = makeConditionalControl({
  control: borderColorControl,
  predicate: isBorderStyleNonNone,
  gatingSource: ConditionalGatingSource.STYLE,
  gatingKey: BORDER_STYLE_PROPERTY,
});

export const conditionalBorderWidthControl: EmailMakerControl = makeConditionalControl({
  control: borderWidthControl,
  predicate: isBorderStyleNonNone,
  gatingSource: ConditionalGatingSource.STYLE,
  gatingKey: BORDER_STYLE_PROPERTY,
});
